"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
const uuid_1 = require("uuid");
const reCalculateDiscountAndSurcharge = (orderItem) => {
    const updatedOrderItem = { ...orderItem };
    updatedOrderItem.discountAmount = (0, utils_1.limitDecimalCount)((0, computePrice_1.computeOrderItemDiscount)(updatedOrderItem));
    updatedOrderItem.surchargeAmount = (0, utils_1.limitDecimalCount)((0, computePrice_1.computeOrderItemSurcharge)(updatedOrderItem));
    return updatedOrderItem;
};
const updateAdjustmentQuantity = (orderItem) => {
    var _a;
    const adjustment = (_a = orderItem.adjustments) === null || _a === void 0 ? void 0 : _a[0];
    if (adjustment && adjustment.adjustmentUnit === domain_1.AdjustmentUnit.FLAT) {
        adjustment.quantity = orderItem.quantity;
    }
    return orderItem;
};
/**
 * Split Order Item Quantity to make payment by split product.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type OrderPayment
 * @param prevState
 */
const updateSplitOrderItem = (originalOrderItem, splitQuantity) => {
    const splitOrderItem = reCalculateDiscountAndSurcharge({
        ...originalOrderItem,
        adjustments: [],
        quantity: splitQuantity,
    });
    const remainOrderItem = reCalculateDiscountAndSurcharge(updateAdjustmentQuantity({
        ...originalOrderItem,
        quantity: (0, utils_1.limitDecimalCount)(originalOrderItem.quantity - splitQuantity),
    }));
    return [remainOrderItem, splitOrderItem];
};
const updateQuantityAndAdjustmentProportion = (originalOrderItem, splitQuantity) => {
    const remainAdjustments = [];
    const splitAdjustments = [];
    const originalQuantity = originalOrderItem === null || originalOrderItem === void 0 ? void 0 : originalOrderItem.quantity;
    (originalOrderItem.adjustments || []).forEach(adjust => {
        if (adjust.adjustmentUnit === domain_1.AdjustmentUnit.FLAT) {
            const splitValue = (0, utils_1.limitDecimalCount)((splitQuantity / originalQuantity) * adjust.amount);
            splitAdjustments.push({
                ...adjust,
                amount: splitValue,
            });
            remainAdjustments.push({
                ...adjust,
                amount: adjust.amount - splitValue,
            });
        }
        else {
            splitAdjustments.push(adjust);
            remainAdjustments.push(adjust);
        }
    });
    const splitOrderItem = reCalculateDiscountAndSurcharge({
        ...originalOrderItem,
        adjustments: splitAdjustments,
        quantity: splitQuantity,
    });
    const remainOrderItem = reCalculateDiscountAndSurcharge({
        ...originalOrderItem,
        adjustments: remainAdjustments,
        quantity: (0, utils_1.limitDecimalCount)(originalQuantity - splitQuantity),
    });
    return [remainOrderItem, splitOrderItem];
};
function default_1(event, prevState) {
    var _a, _b;
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    // update quantity of Source Order Item
    const originalOrderItem = (_a = ((order === null || order === void 0 ? void 0 : order.orderItems) || [])) === null || _a === void 0 ? void 0 : _a.find(orderItem => orderItem.id === event.orderItemId);
    const originalOrderItemIndex = (_b = ((order === null || order === void 0 ? void 0 : order.orderItems) || [])) === null || _b === void 0 ? void 0 : _b.indexOf(originalOrderItem);
    if (!originalOrderItem || !(0, utils_1.isItemEditable)(originalOrderItem)) {
        return order;
    }
    const splitQuantity = event.quantity;
    const originalQuantity = originalOrderItem === null || originalOrderItem === void 0 ? void 0 : originalOrderItem.quantity;
    const remainQuantity = originalQuantity - splitQuantity;
    if (remainQuantity <= 0)
        return order;
    /**
     * splitViaAdvanceDiscountRule is set to true if splitting is done via advance discount rule
     * Description:
     *    For this split rule, we're only going to split the item and not split the adjustment between items;
     *    adjustments are only assigned to original item
     * splitViaAdvanceDiscountRule is always falsy for current split so normal flow won't affected
     */
    const [remainOrderItem, splitOrderItem] = !event.splitViaAdvanceDiscountRule
        ? updateQuantityAndAdjustmentProportion(originalOrderItem, splitQuantity)
        : updateSplitOrderItem(originalOrderItem, splitQuantity);
    splitOrderItem.createdAt = Date.now();
    splitOrderItem.id = event.splitOrderItemId || (0, uuid_1.v4)();
    order.orderItems = order.orderItems.map(item => {
        if (item.id === originalOrderItem.id)
            return remainOrderItem;
        return item;
    });
    splitOrderItem['originalOrderItemId'] =
        (originalOrderItem === null || originalOrderItem === void 0 ? void 0 : originalOrderItem.originalOrderItemId) || originalOrderItem.id;
    order.orderItems.splice(originalOrderItemIndex + 1, 0, splitOrderItem);
    return {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
    };
}
exports.default = default_1;
//# sourceMappingURL=splitQuantityOrderItem.js.map